export default __webpack_public_path__ + "static/media/smb.f12b0dbf.svg";